import React, {  } from 'react';

import { collateOptions } from '../types';
import { IntlFunction } from './Intl.Function';
import { StringLocaleCompareInput } from './Intl.Collator';

export const StringLocaleCompare = () => (
	<IntlFunction
		input={StringLocaleCompareInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare"
		header="String.prototype.localeCompare"
		description="Returns a number indicating whether a reference string comes before, or after, or is the same as the given string in sort order."
		options={collateOptions}
		ruleSet={[]}
		template="##input##.localeCompare(##input##, ##locale##, ##options##)" />
)